import { render, staticRenderFns } from "./AllActiveTradesModal.vue?vue&type=template&id=45ea004c&scoped=true&"
import script from "./AllActiveTradesModal.vue?vue&type=script&lang=js&"
export * from "./AllActiveTradesModal.vue?vue&type=script&lang=js&"
import style0 from "./AllActiveTradesModal.vue?vue&type=style&index=0&id=45ea004c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ea004c",
  null
  
)

export default component.exports